import axios from "axios";
import { environment } from "../../environments/environment";
import { ListResponse } from "./utils";

export interface Benefit {
    id: number,
    name: string,
    simplified_name: string,
    has_value: boolean,
    has_time_unit: boolean,
    is_active: boolean
}

export const listBenefits = async (candidate_id?: any): Promise<ListResponse<Benefit>> => {
    const response = await axios.get<ListResponse<Benefit>>(
        environment.apiUrl+'/api/benefits' + (candidate_id ? '?candidate_id='+candidate_id : ''), {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+localStorage.getItem('auth_token')
        }
    });

    if(response.status !== 200) {
        throw Error('error');
    };

    return response.data;
};

export const createBenefit = async (data: Benefit): Promise<ListResponse<Benefit>> => {
    const response = await axios.post<ListResponse<Benefit>>(environment.apiUrl+'/api/course/', data, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+localStorage.getItem('auth_token')
        }
    });

    if(response.status !== 201) {
        throw Error('error');
    };

    return response.data;
};